import React, { useEffect, useState } from 'react'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData } from './store/dataSlice'
injectReducer('fileDirectory', reducer)

export default function FileDirectory() {
    const dispatch = useDispatch()
    const { data, loading } = useSelector(state => state.fileDirectory.data)
    const { company, customer } = useSelector(state => state.filterData)
    const { companyData, customersData } = useSelector(state => state.listData)

    const [path, setPath] = useState(['Home'])

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    const fetchData = data =>
        dispatch(
            getData({
                ...data,
                company: company ? companyData?.find(item => item?.id?.toString() === company?.toString())?.code : '',
                customer: customer
                    ? customersData?.find(item => item?.id?.toString() === customer?.toString())?.customer_code
                    : '',
            })
        )

    // if (loading) {
    //     return (
    //         <div className="flex items-center justify-center h-64">
    //             <div className="text-lg text-gray-600">Loading...</div>
    //         </div>
    //     )
    // }

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">File Directory</h2>
            </div>
            <div className="rounded-sm border border-stroke bg-white dark:border-strokedark dark:bg-boxdark">
                {loading ? (
                    <div className="flex items-center justify-center h-24">
                        <div className="text-lg text-gray-600">Loading...</div>
                    </div>
                ) : (
                    <div className="border-t border-stroke p-5 dark:border-strokedark sm:p-6">
                        <div className="flex items-center gap-2 mb-4">
                            {path?.map((p, i) => (
                                <div key={i} className="flex items-center">
                                    <button
                                        className="text-info hover:underline"
                                        onClick={() => {
                                            fetchData({ path: i === 0 ? '' : p })
                                            let pathArr = [...path]
                                            pathArr.splice(i + 1)
                                            setPath(pathArr)
                                        }}
                                    >
                                        {p.split('/')[p.split('/').length - 1]}
                                    </button>
                                    {i < path.length - 1 && <span className="mx-2">/</span>}
                                </div>
                            ))}
                        </div>
                        {data?.length ? (
                            <div className="grid grid-cols-1 gap-2 sm:grid-cols-12 sm:gap-2">
                                {(data || [])?.map((item, index) => (
                                    <div
                                        key={`folder-${index}`}
                                        className={`bg-white px-6 py-6 dark:bg-boxdark xl:py-[27px] ${item.type !== 'file' && 'cursor-pointer'}`}
                                        onClick={() => {
                                            if (item.type !== 'file') {
                                                fetchData({ path: item?.path })
                                                let pathArr = [...path]
                                                pathArr.push(item?.path)
                                                setPath(pathArr)
                                            }
                                        }}
                                    >
                                        <div className="flex justify-center">
                                            {item.type === 'file' ? (
                                                <div>
                                                    <svg
                                                        className="fill-[#F05540]"
                                                        width="35"
                                                        height="33"
                                                        viewBox="0 0 25 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            clip-rule="evenodd"
                                                            d="M19.8335 19.75C19.8335 20.9926 18.8261 22 17.5835 22H7.0835C5.84086 22 4.8335 20.9926 4.8335 19.75V9.62105C4.8335 9.02455 5.07036 8.45247 5.49201 8.03055L10.8597 2.65951C11.2817 2.23725 11.8542 2 12.4512 2H17.5835C18.8261 2 19.8335 3.00736 19.8335 4.25V19.75ZM17.5835 20.5C17.9977 20.5 18.3335 20.1642 18.3335 19.75V4.25C18.3335 3.83579 17.9977 3.5 17.5835 3.5H12.5815L12.5844 7.49913C12.5853 8.7424 11.5776 9.75073 10.3344 9.75073H6.3335V19.75C6.3335 20.1642 6.66928 20.5 7.0835 20.5H17.5835ZM7.39262 8.25073L11.0823 4.55876L11.0844 7.5002C11.0847 7.91462 10.7488 8.25073 10.3344 8.25073H7.39262ZM8.5835 14.5C8.5835 14.0858 8.91928 13.75 9.3335 13.75H15.3335C15.7477 13.75 16.0835 14.0858 16.0835 14.5C16.0835 14.9142 15.7477 15.25 15.3335 15.25H9.3335C8.91928 15.25 8.5835 14.9142 8.5835 14.5ZM8.5835 17.5C8.5835 17.0858 8.91928 16.75 9.3335 16.75H12.3335C12.7477 16.75 13.0835 17.0858 13.0835 17.5C13.0835 17.9142 12.7477 18.25 12.3335 18.25H9.3335C8.91928 18.25 8.5835 17.9142 8.5835 17.5Z"
                                                            fill=""
                                                        ></path>
                                                    </svg>
                                                </div>
                                            ) : (
                                                <div>
                                                    <svg
                                                        width="36"
                                                        height="36"
                                                        viewBox="0 0 36 36"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            clip-rule="evenodd"
                                                            d="M13.3986 4.40674C12.9265 3.77722 12.1855 3.40674 11.3986 3.40674H2.5C1.11929 3.40674 0 4.52602 0 5.90674V30.0959C0 31.4766 1.11929 32.5959 2.5 32.5959H33.5C34.8807 32.5959 36 31.4766 36 30.0959V11.7446C36 10.3639 34.8807 9.24458 33.5 9.24458H18.277C17.4901 9.24458 16.7492 8.87409 16.277 8.24458L13.3986 4.40674Z"
                                                            fill="url(#paint0_linear_2816_28044)"
                                                        ></path>
                                                        <defs>
                                                            <linearGradient
                                                                id="paint0_linear_2816_28044"
                                                                x1="18"
                                                                y1="3.40674"
                                                                x2="18"
                                                                y2="32.5959"
                                                                gradientUnits="userSpaceOnUse"
                                                            >
                                                                <stop stop-color="#FFDC78"></stop>
                                                                <stop offset="1" stop-color="#FBBC1A"></stop>
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                        <h4 className="text-sm text-center font-medium text-black dark:text-white">
                                            {item?.name}
                                        </h4>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="flex items-center justify-center h-24">
                                <div className="text-lg text-center">Empty Folder</div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    )
}
